import React from 'react';
import { SortableHandle } from 'react-sortable-hoc';
import { FAIcon } from '../../fa-icon/component.js';

var LegacyDragHandle = function LegacyDragHandle(_ref) {
  var isSortable = _ref.isSortable;
  if (!isSortable) return null;
  var LegacyDragHandle = SortableHandle(function () {
    return /*#__PURE__*/React.createElement("div", {
      className: "sortable-handle p-r-20"
    }, /*#__PURE__*/React.createElement(FAIcon, {
      icon: "grip-dots"
    }));
  });
  return /*#__PURE__*/React.createElement(LegacyDragHandle, null);
};

LegacyDragHandle.displayName = "LegacyDragHandle";
export { LegacyDragHandle };